<template>
  <div>
    <card-form
      class="pt-2"
      v-bind="$attrs"
      :collapsed="true"
    >
      <template #expanded>
        <div>
          <div class="mb-4 header-card">
            <div>
              <h2 class="title-main">
                {{ title }}
              </h2>
            </div>
            <slot name="headerAction" />
          </div>
          <div>
            <slot />
          </div>
        </div>
      </template>
    </card-form>
  </div>
</template>

<script>
import CardForm from './CardForm.vue'

export default {
  name: 'Card',
  components: {
    CardForm
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.card-form__container {
  border-radius: 8px;
  padding-bottom: 18px;
}
.gap-card {
  gap: 20px 0;
}

.header-card {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;

  div {
    flex: 1;
  }
}
</style>
